module.exports = __webpack_public_path__ + "img/sale.f827943b.svg";